import React from 'react';
import {styled} from 'styled-components';
import {colors} from '../../styles/colors';
import {useFormatMsg} from 'utils/useFormatMsg';
import {FormattedMessage} from 'react-intl';
import {minmax} from 'utils/minmax';

/**
 * 기본 텍스트 컴포넌트의 Props 인터페이스
 * @property {string | undefined} text - 표시할 텍스트
 * @property {React.CSSProperties} [textStyle] - 텍스트 스타일
 * @property {() => void} [onClick] - 클릭 이벤트 핸들러
 * @property {React.RefObject<HTMLDivElement>} [ref] - 참조 객체
 * @property {React.CSSProperties} [formattedMessageStyle] - 포맷된 메시지 스타일
 * @property {string} [tooltip] - 툴팁 텍스트
 * @property {() => void} [onMouseEnter] - 마우스 진입 이벤트 핸들러
 * @property {() => void} [onMouseLeave] - 마우스 나가기 이벤트 핸들러
 * @property {string} [as] - 렌더링할 HTML 태그
 */
interface IDefaultText {
  text: string | undefined;
  textStyle?: React.CSSProperties;
  onClick?: () => void;
  ref?: React.RefObject<HTMLDivElement>;
  formattedMessageStyle?: React.CSSProperties;
  tooltip?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  as?: keyof JSX.IntrinsicElements;
}

/**
 * 기본 텍스트 컴포넌트
 * 공통으로 사용되는 텍스트 컴포넌트입니다.
 * @param {IDefaultText} props - 텍스트 컴포넌트의 props
 * @returns {JSX.Element} 기본 텍스트 컴포넌트
 */
const DefaultText = ({
  text,
  textStyle,
  onClick,
  ref,
  formattedMessageStyle,
  tooltip,
  onMouseEnter,
  onMouseLeave,
  as,
}: IDefaultText) => {
  // const txt = textKey ? useFormatMsg(textKey) : text;
  const txt = useFormatMsg(text) || text;

  return (
    <TextStyle
      style={textStyle as any}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      title={tooltip}
      {...(as && {as})}>
      {formattedMessageStyle && text ? (
        <FormattedMessage
          id={text}
          values={{
            b: format => (
              <TextStyle style={formattedMessageStyle as any} as="span">
                {format}
              </TextStyle>
            ),
          }}
        />
      ) : (
        txt
      )}
    </TextStyle>
  );
};

export const TextStyle = styled.p`
  font-family: 'Noto Sans KR', sans-serif;
  font-size: ${minmax(20)};
  font-weight: 400;
  color: ${colors.black};
  line-height: normal;
  word-break: break-all;
`;

export default DefaultText;
